<template>
  <div class="ibi-cont">
    <ChartsLayout
      :chartview="chartview"
      class_chart="ibi-chart"
    />
  </div>
</template>


<style lang="scss">
 @import '@/sass/explorer.scss';

 .ibi-cont {
   width: 100%;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
 }

 .ibi-chart {
   padding: 10px;
   border-radius: 10px;
   /* border-style: solid;
      border-width: 1px;
      border-color: $primary; */
   height: 250px;
 }
</style>


<script>
 import ChartsLayout from '@/components/charts/ChartsLayout'

 export default {
   name: 'InlineBoxIndicator',

   props: {
     current_qunit: Object,
     props: Object,
     is_mobile: {type: Boolean, default: false},
   },

   components: {
     ChartsLayout,
   },

   data: (() => ({
     extended: [],
     value: true,
   })),

   mounted() {
   },

   computed: {
     chartview() {
       return this.props.charts;
     }
   },

   methods: {
   },
 }
</script>
